module.exports = __webpack_public_path__ + "static/media/11.9f5dbdd9.png";